const VALID_STATUSES = new Set(["draft", "published", "archived"]);

export const createCourseBulkMutationService = (
  client,
  cleanupStorage = null,
) => ({
  async changeStatus(courseIds, status) {
    if (!Array.isArray(courseIds) || courseIds.length === 0) {
      throw new Error("Select at least one course");
    }
    if (!VALID_STATUSES.has(status)) throw new Error("Invalid course status");
    const { data, error } = await client.rpc("bulk_change_course_status", {
      p_course_ids: courseIds,
      p_status: status,
    });
    if (error) throw error;
    if (Number(data?.updated) !== courseIds.length) {
      throw new Error("Not every selected course was updated");
    }
    return data;
  },

  async remove(courseIds) {
    if (!Array.isArray(courseIds) || courseIds.length === 0) {
      throw new Error("Select at least one course");
    }
    const { data, error } = await client.rpc("bulk_delete_courses_safely", {
      p_course_ids: courseIds,
    });
    if (error) throw error;
    const results = Array.isArray(data?.results) ? data.results : [];
    if (results.length !== courseIds.length) {
      throw new Error("Bulk course deletion returned an incomplete result");
    }

    const warnings = [];
    if (cleanupStorage && data.storage_candidates?.length > 0) {
      try {
        await cleanupStorage(data.storage_candidates);
      } catch (cleanupError) {
        warnings.push(
          `Course records changed, but storage cleanup failed: ${cleanupError.message}`,
        );
      }
    }

    return {
      deletedIds: results.filter((item) => item.deleted).map((item) => item.id),
      archivedIds: results.filter((item) => item.archived).map((item) => item.id),
      warnings,
    };
  },
});
